var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = { circles: true }, _obj[_vm.color] = true, _obj )},[_c('div',{staticClass:"circle"}),_vm._v(" "),_c('div',{staticClass:"circle small"})])}
var staticRenderFns = []

export { render, staticRenderFns }